import { api } from '@services';
import Picture, { IPicture, IPictureApiModel } from '@models/Picture.model';

interface IGetPicturesByEquipment {
  id: string;
}

const getPicturesByEquipment = async ({
  id,
}: IGetPicturesByEquipment): Promise<IPicture[]> => {
  const { data: pictures } = await api.get<IPictureApiModel[]>(
    `/equipments/${id}/pictures`,
  );

  return Picture.arrayFromApiModel(pictures);
};

export { getPicturesByEquipment };
